<script setup lang="ts">
import type { DocumentNode, TextNode } from '~/lib/bosca/document.ts'

const props = defineProps<{
  node: DocumentNode
  item: any
}>()

const classNames = computed(() => {
    if (!props.node.marks) {
        return ''
    }
    let names = ''
    for (const mark of props.node.marks) {
        switch (mark.type) {
        case 'bold':
            names += 'font-bold '
            break
        case 'italic':
            names += 'italic '
            break
        }
    }
    return names
})
const linkHref = computed(() => {
    if (!props.node.marks) {
        return null
    }
    for (const mark of props.node.marks) {
        if (mark.type === 'link') {
            return mark.attrs?.href || mark.attrs?.url
        }
    }
    return null
})
</script>

<template>
  <template v-if="classNames.length > 0">
    <template v-if="linkHref">
      <a
        :href="linkHref"
        :class="classNames"
      >{{ (node as TextNode).text }}</a>
    </template>
    <template v-else>
      <span
        :class="classNames"
        data-node-type="text"
      >
        {{ (node as TextNode).text }}
      </span>
    </template>
  </template>
  <template v-else>
    <template v-if="linkHref">
      <a :href="linkHref">{{ (node as TextNode).text }}</a>
    </template>
    <template v-else>
      {{ (node as TextNode).text }}
    </template>
  </template>
</template>
